type Path = `/${string}`;

/**
 * Creates a link for the given path, keeping account whether a user is an agent or client
 * Defaults to agent, unless a client id is provided
 * @param {string} path the path to go to
 * @param {string | undefined} clientId The client id, if current user is a client
 */
export const createLink = (path: Path, clientId?: string | undefined) => [clientId && `/client/${clientId}`, path].filter(Boolean).join("");
